export const feesData = [
    {
      key: "1",
      id: "FG80482",
      feesGroup: "Tuition Fees",
      description: "The money that you pay to be taught",
      status: "Active",
      statusClass: "badge badge-soft-success",
    },
    {
      key: "2",
      id: "FG80481",
      feesGroup: "Monthly Fees",
      description: "The money that you pay to be taught",
      status: "Active",
      statusClass: "badge badge-soft-success",
    },
    {
      key: "3",
      id: "FG80480",
      feesGroup: "Class 1 General",
      description: "The money that you pay to be taught",
      status: "Active",
      statusClass: "badge badge-soft-success",
    },
    {
      key: "4",
      id: "FG80479",
      feesGroup: "Class 1 Lump Sum",
      description: "The money that you pay to be taught",
      status: "Active",
      statusClass: "badge badge-soft-success",
    },
    {
      key: "5",
      id: "FG80478",
      feesGroup: "Class 1- I Installment",
      description: "The money that you pay to be taught",
      status: "Inactive",
      statusClass: "badge badge-soft-danger",
    },
    {
      key: "6",
      id: "FG80477",
      feesGroup: "Class 1-II Installment",
      description: "The money that you pay to be taught",
      status: "Active",
      statusClass: "badge badge-soft-success",
    },
    {
      key: "7",
      id: "FG80476",
      feesGroup: "Class 1-III Installment",
      description: "The money that you pay to be taught",
      status: "Active",
      statusClass: "badge badge-soft-success",
    },
    {
      key: "8",
      id: "FG80475",
      feesGroup: "Discount",
      description: "The money that you pay to be taught",
      status: "Inactive",
      statusClass: "badge badge-soft-danger",
    },
    {
      key: "9",
      id: "FG80474",
      feesGroup: "Class 3- I Installment",
      description: "The money that you pay to be taught",
      status: "Active",
      statusClass: "badge badge-soft-success",
    },
    {
      key: "10",
      id: "FG80473",
      feesGroup: "Class 4- I Installment",
      description: "The money that you pay to be taught",
      status: "Active",
      statusClass: "badge badge-soft-success",
    },
    {
      key: "11",
      id: "FG80482",
      feesGroup: "Tuition Fees",
      description: "The money that you pay to be taught",
      status: "Active",
      statusClass: "badge badge-soft-success",
    },
    {
      key: "12",
      id: "FG80481",
      feesGroup: "Monthly Fees",
      description: "The money that you pay to be taught",
      status: "Active",
      statusClass: "badge badge-soft-success",
    },
  ];